import { RefObject } from 'react';

interface Parameters {
  item: { id: string };
  index: number;
  draggingId: string | null;
  orderedList: Array<{ id: string }>;
  listContainerRef: RefObject<HTMLDivElement | null>;
  refsByKey: Record<string, HTMLElement | null>;
}

const OFFSET = 3;

export const calculateItemJoinerCoordinates = ({
  item,
  index,
  draggingId,
  orderedList,
  listContainerRef,
  refsByKey,
}: Parameters) => {
  const isLast = index === orderedList.length - 1;
  let [x1, x2, y1, y2]: (number | null)[] = [null, null, null, null];

  if (draggingId || isLast) {
    return [x1, x2, y1, y2];
  }

  const key = `${item.id}-priority`;
  const nextKey = `${orderedList[index + 1]?.id}-priority`;

  const listContainer = listContainerRef.current;
  const refsDefined = listContainer && refsByKey[key] && refsByKey[nextKey];

  if (!refsDefined) {
    return [x1, x2, y1, y2];
  }

  // origin of SVG
  const x0 = listContainer.getBoundingClientRect().left;
  const y0 = listContainer.getBoundingClientRect().top;

  x1 =
    (refsByKey[key]!.getBoundingClientRect().left +
      refsByKey[key]!.getBoundingClientRect().right) /
    2;
  y1 = refsByKey[key]!.getBoundingClientRect().bottom;

  x2 = x1;
  y2 = refsByKey[nextKey]!.getBoundingClientRect().top;

  return [x1 - x0, x2 - x0, y1 - y0 + OFFSET, y2 - y0 - OFFSET];
};
